import { render } from "./ImagePreview.vue?vue&type=template&id=6772d994"
import script from "./ImagePreview.vue?vue&type=script&lang=js"
export * from "./ImagePreview.vue?vue&type=script&lang=js"

import exportComponent from "E:\\wwwroot\\HanMaWeb\\trunk\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__